"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config = {
    eosContentUrl: "/services/content/eos-content.js"
};
exports.default = config;
//# sourceMappingURL=config.js.map